import { render, staticRenderFns } from "./PlantList.vue?vue&type=template&id=6927df7e&"
import script from "./PlantList.vue?vue&type=script&lang=js&"
export * from "./PlantList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports